import '../../../styling/Styles.css';

//  This function loads all the custom made panels to load in GrapesJs
const LoadPanels = () => {
    
    const tempPanels = [
        /*
        Device manager panel contains all the available options to set the mode of the view in canvas of GrapesJs
        Desktop device view, Mobile device view and tablet device view
        */
        {
          id: "device_manager",
          el: ".device_manager",
          buttons:[
            {
              id: "cmdDeviceDesktop",
              command: "set-device-desktop",
              className: 'fa fa-desktop gjs-pn-btn4  gjs-pn-width',
              attributes: {
                'data-tooltip': 'Desktop device',
                'data-tooltip-pos': "bottom",
              },
            },
            {
              id: "cmdDeviceTablet",
              command: "set-device-tablet",
              className: 'fa fa-tablet gjs-pn-btn4  gjs-pn-width',
              attributes: {
                'data-tooltip': 'Tablet device',
                'data-tooltip-pos': "bottom",
              },
            },
            {
              id: "cmdDeviceMobile",
              command: "set-device-mobile",
              className: 'fa fa-mobile gjs-pn-btn4  gjs-pn-width',
              attributes: {
                'data-tooltip': 'Mobile device',
                'data-tooltip-pos': "bottom",
              },
            },
          ]
        },
        {
          id: 'view_annotations',
          el: '.view_annotations',
          buttons:[
            {
              id: 'view-annotations1',
              className:  "far fa-file-alt fa-file-alt2 gjs-pn-btn4",
              command: 'view-annotations',
              attributes: {
                'data-tooltip': 'View annotations',
                'data-tooltip-pos': "bottom"
              }
            }
          ]
        },
        {
          id: 'enable_dragMode',
          el: '.enable_dragMode',
          buttons:[
            {
              id: 'enable_dragMode1',
              className: "fas fa-arrows-alt fa-arrows-alt2 gjs-pn-btn4",
              command: 'command-enable-drag-drop',
              attributes: {
                'data-tooltip': 'Enable absolute movement',
                'data-tooltip-pos': "bottom"
              }
            } 
          ]
        },
        //  Panel basic actions view contains all the available options of commands to canvas of GrapesJs
        {
          id: "basic-actions",
          el: ".panel__basic-actions",
          buttons: [
            {
              id: "clear-canvas",
              className: "fas fa-broom  gjs-pn-btn4 ",
              command: "command-clear-canvas",
              attributes: {
                'data-tooltip': 'Clear canvas',
                'data-tooltip-pos': "bottom",
              },
            },
            
            // TODO: This command is not working properly we need to implement its functionality
            // {
            //   id: "apply-same-styling",
            //   className: "fas fa-palette gjs-pn-btn4",
            //   command: "command-apply-same-styling",
            //   attributes: {
            //     'data-tooltip': 'Apply styling',
            //     'data-tooltip-pos': "bottom",  
            //   },
            // },
            
            {
              id: "undo",
              className: "fa fa-undo gjs-pn-btn4",
              command: "command-undo",
              attributes: {
                'data-tooltip': 'Undo',
                'data-tooltip-pos': "bottom",
              },
            },
            {
              id: "redo",
              className: "fa fa-repeat gjs-pn-btn4",
              command: "command-redo",
              attributes: {
                'data-tooltip': 'Redo',
                'data-tooltip-pos': "bottom",
              },
            },
            {
              id: "fullscreen1",
              className: "fa fa-expand gjs-pn-btn4",
              command: "command-fullscreen",
              attributes: {
                'data-tooltip': 'Fullscreen',
                'data-tooltip-pos': "bottom",
              },
            },
            {
              id: "export1",
              className: "fas fa-file-export gjs-pn-btn4",
              command: 'command-export',
              attributes: {
                  'data-tooltip': 'Export code',
                  'data-tooltip-pos': "bottom",
                }
              },
              {
                id: "preview1",
                className: "fa fa-eye fa-eye3 gjs-pn-btn4",
                command: "command-preview",
                attributes: {
                  'data-tooltip': 'Preview',
                  'data-tooltip-pos': "bottom",
                },
            },

          ]
        },
      /*
      Panel switcher panel contains all the availables tabs near the canvas of grapesJs. Every tab contains a diferrent manager
      BlocksManager, StylesManager, DataManager, LayersManager
      */
      {
        id: "panel-switcher",
        el: ".panel__switcher",
        buttons: [
          {
            id: "show-blocks",
            active: true,
            label: "Blocks",
            className: "blocks-button",
            command: "show-blocks",
            // Once activated disable the possibility to turn it off
            togglable: false
          },
          {
            id: "show-style",
            active: false,
            label: "Styles",
            className: "styles-button styles-button-active",
            command: "show-styles",
            togglable: false
          },
          {
            id: "show-data",
            active: false,
            label: "Data",
            className: "data-button",
            command: "show-data",
            togglable: false
          },
          {
            id: 'show-layers',
            active: false,
            label: 'Layers',
            className: 'layers-button',
            command: "show-layers",
            togglable: false
          }
        ]
      }
      ]
      return tempPanels;
}

export default LoadPanels; 